import { createContext, useContext } from "react";

import OOMRootStore, { OOMRootStoreInstance } from "./OOMRootStore";
/**
 * Create a context we can use to
 * - Provide access to our stores from our root component
 * - Consume stores in our screens (or other components, though it's
 *   preferable to just connect screens)
 */
const OOMRootStoreContext = createContext(OOMRootStore);

/**
 * The provider our root component will use to expose the root store
 */
export const OOMRootStoreProvider = OOMRootStoreContext.Provider;

/**
 * A hook that screens can use to gain access to our stores, with
 * `const { someStore, someOtherStore } = useStores()`,
 * or less likely: `const OOMRootStore = useStores()`
 */
export const useOOMStores = (): OOMRootStoreInstance => useContext(OOMRootStoreContext);

export { default as OOMRootStore } from "./OOMRootStore";
